import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTelecallerFeedback } from "../../../../store/telecaller/cases";
import "./Feedback.scss";
import moment from "moment/moment";
import { Card } from "antd";

const Feedback = ({ data }) => {
    const dispatch = useDispatch();
    const { feedback, feedback_loading } = useSelector((state) => state.telecallerCases);
    const { telecaller_feedback = [] } = feedback || {};

    useEffect(() => {
        if (data?.id) {
            dispatch(fetchTelecallerFeedback({ id: data.id }));
        }
    }, [dispatch, data?.id]);
    return (

        telecaller_feedback?.map((item, index) => {
            if (feedback_loading) {
                return <Card loading={true} style={{padding:'20px'}}/>
            }
            return (
                <div key={index} className="customerLoanInfoContainer">
                    <div className="feedbackHeader">
                        <h2 className="feedbackTitle">Feedback {index + 1}</h2>
                    </div>
                    <div className="InfoContainerBox">
                        <div className="detailInfoSect marginBtm">
                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Date</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">
                                        {item?.date ? moment(item.date).format('MM-DD-YYYY') : '' || "N/A"}
                                    </p>
                                </div>
                            </div>

                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Call Status</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">{item.call_status?.value || "N/A"}</p>
                                </div>
                            </div>

                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Sub-status</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">{item.call_sub_status || "—"}</p>
                                </div>
                            </div>

                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Attended By</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">{item.call_attend_by || "—"}</p>
                                </div>
                            </div>
                        </div>

                        <div className="detailInfoSect topPadding">
                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Comment</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">{item.comment || "—"}</p>
                                </div>
                            </div>

                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Notes</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">{item.notes || "—"}</p>
                                </div>
                            </div>

                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Paid Amount</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">₹{item.paid_amount || "0"}</p>
                                </div>
                            </div>

                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Bucket ID</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">{item.xbucket || "—"}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    );
};

export default Feedback;
